// Deterministic single-winner hit rule for map entity features.
//
// queryRenderedFeatures returns rendered features top-first by render order, so the winner
// under a cursor is "the first feature the user can actually see there". Determinism comes
// from the layer stack, not from this function: entity layers are registered in a fixed
// order, and only rendered symbols are returned, so the same scene always yields the same
// array order. There is deliberately no chooser, cycling, or multi-select — one query, one
// winner, identical for hover and click.

interface FeatureLike {
    properties: Record<string, unknown>;
}

/**
 * Picks the single feature a hover/click at a point resolves to, or null when nothing
 * (or only a cluster) is hit.
 *
 * A cluster bubble on top aborts the pick entirely rather than falling through to markers
 * rendered beneath it: a click on a bubble belongs to the cluster interaction (zoom/expand),
 * and selecting a half-hidden marker under it would make one click do two things.
 */
export function pickTopEntityFeature<T extends FeatureLike>(features: readonly T[]): T | null {
    if (features.length === 0) return null;
    if (features[0].properties['cluster_id'] != null) return null;
    return features[0];
}
